module.exports = __webpack_public_path__ + "static/special-037f5e745ef87719f6fec35fed4ec14b.png";